class mediaDeviceClass {
    constructor(params) {
        this.module_name = params.module_name;
        this.event_screen_module_id = params.event_screen_module_id;
        this.callType = params.callType;
        this.audioMandatory = params.audioMandatory;
        this._selectedDevices = {audiooutput: "", audioinput: "", videoinput: ""};
        this.missingDevices = {audiooutput: true, audioinput: true, videoinput: true};
        

        this.localMediaDevices = [];
        
        this.init();
    }

    get getSelectedDevices() {
        return this._selectedDevices;
    }

    get getLocalMediaDevices() {
        return this.localMediaDevices;
    }

    set selectedDevices(selectedDevices) {
        this._selectedDevices = selectedDevices;
        this.saveLocalStorage(this._selectedDevices); 
    }

    getLocalStorage() {
        let locallyStoredDevices=JSON.parse(localStorage.getItem(this.module_name+'_devices_'+this.event_screen_module_id));
        return locallyStoredDevices;
    }

    saveLocalStorage(selectedDevices) {
        // Persist deviceIds alongside labels so they survive label changes (e.g. after permissions granted)
        const deviceIds = {};
        for (const kind of ['audiooutput', 'audioinput', 'videoinput']) {
            const label = selectedDevices[kind];
            const dev = label ? this.localMediaDevices.find(d => d.kind === kind && d.label === label) : null;
            deviceIds[kind] = dev ? dev.deviceId : '';
        }
        localStorage.setItem(
            this.module_name+'_devices_'+this.event_screen_module_id,
            JSON.stringify({ ...selectedDevices, deviceIds })
        );
    }

    needsSetup() {
        // missingDevices stays all-true when no localStorage exists (updateDevices skips the validation block)
        return this.missingDevices.audioinput || this.missingDevices.videoinput;
    }

    getDeviceID(deviceKind) {
    console.log(deviceKind)
    console.log(this.localMediaDevices)

        let index = this.localMediaDevices.findIndex(
                mediaDevices => mediaDevices.kind === deviceKind && mediaDevices.label === this._selectedDevices[deviceKind]);
        if (index !== -1) {
            if (deviceKind === 'audiooutput') {
                console.log('found audio output device ',this.localMediaDevices[index].deviceId)
                return this.localMediaDevices[index].deviceId;
            } else {
                let constraint = {echoCancellation: false,
                                  noiseSuppression: false,
                                  autoGainControl: false,
                                  volume: 1,
                                  deviceId: {exact: this.localMediaDevices[index].deviceId}
                                 }
                                
                return constraint
            }
        } else {
            return false;
        }

    }

    

    updateDevices(deviceInfo) {
        let locallyStoredDevices = this.getLocalStorage();

        if (locallyStoredDevices !== null){
            this.missingDevices = {audiooutput: false, audioinput: false, videoinput: false};
            this._selectedDevices.audiooutput = locallyStoredDevices.audiooutput;
            this._selectedDevices.audioinput = locallyStoredDevices.audioinput;
            this._selectedDevices.videoinput = locallyStoredDevices.videoinput;

            const storedIds = locallyStoredDevices.deviceIds || {};

            for (const kind of ['audioinput', 'audiooutput', 'videoinput']) {
                const storedLabel = locallyStoredDevices[kind];
                if (!storedLabel || storedLabel.length === 0) continue;

                // Try matching by stored deviceId first — survives label changes after permissions are granted
                const storedId = storedIds[kind];
                let matched = false;
                if (storedId) {
                    const idx = deviceInfo.findIndex(d => d.kind === kind && d.deviceId === storedId && d.deviceId !== 'default');
                    if (idx !== -1) {
                        // Use the current label (may differ from stored label if permissions just granted)
                        const currentLabel = deviceInfo[idx].label;
                        if (currentLabel.length > 0) this._selectedDevices[kind] = currentLabel;
                        matched = true;
                    }
                }

                // Fall back to label match (backward compatibility with old storage format)
                if (!matched) {
                    const idx = deviceInfo.findIndex(d => d.kind === kind && d.label === storedLabel);
                    if (idx !== -1) matched = true;
                }

                if (!matched) {
                    this.missingDevices[kind] = true;
                }
            }
        }

        this.localMediaDevices = [];
        let lastKind="";
        for (var x = 0; x < deviceInfo.length; x++) {
            if (deviceInfo[x].deviceId !== 'default') {
                // default not a valid deviceId and we will ignore this. We take the firast entry of kind to be the default
                let newDevice = {};
                newDevice.deviceId = deviceInfo[x].deviceId;
                newDevice.groupId = deviceInfo[x].groupId;
                newDevice.kind = deviceInfo[x].kind;
                newDevice.label = deviceInfo[x].label.length > 0 ?  deviceInfo[x].label : "Device "+ x;
               if (deviceInfo[x].kind != lastKind) {
                    // this is the default entry
                    lastKind = deviceInfo[x].kind;
                    newDevice.default = true;
                    if (this.missingDevices[deviceInfo[x].kind]) {
                        // this is missing so get the default
                        this._selectedDevices[deviceInfo[x].kind] = newDevice.label; // display the default devices on the droplist title
                    }
                } else {
                    newDevice.default = false;
                }
                this.localMediaDevices.push(newDevice);
            }

        }

        // Allow a none device
        let newDevice = {};
        newDevice.kind = 'videoinput';
        newDevice.label = 'None';
        this.localMediaDevices.push(newDevice);

        if (!this.audioMandatory) {
            newDevice = {};
            newDevice.kind = 'audioinput';
            newDevice.label = 'None';
            this.localMediaDevices.push(newDevice);
        }
       


        if (this.callType==='audio') {
            // force disable video device capability
            //this._selectedDevices.videoinput=""
        }


        this.saveLocalStorage(this._selectedDevices); 



    }

    init() {
        
      
    }


}

let eventMixin = {
    /**
     * Subscribe to event, usage:
     *  menu.on('select', function(item) { ... }
    */
    on(eventName, handler) {
      if (!this._eventHandlers) this._eventHandlers = {};
      if (!this._eventHandlers[eventName]) {
        this._eventHandlers[eventName] = [];
      }
      this._eventHandlers[eventName].push(handler);
    },
  
    /**
     * Cancel the subscription, usage:
     *  menu.off('select', handler)
     */
    off(eventName, handler) {
      let handlers = this._eventHandlers && this._eventHandlers[eventName];
      if (!handlers) return;
      for (let i = 0; i < handlers.length; i++) {
        if (handlers[i] === handler) {
          handlers.splice(i--, 1);
        }
      }
    },
  
    /**
     * Generate the event and attach the data to it
     *  this.trigger('select', data1, data2);
     */
    trigger(eventName, ...args) {
      if (!this._eventHandlers || !this._eventHandlers[eventName]) {
        return; // no handlers for that event name
      }
  
      // call the handlers
      this._eventHandlers[eventName].forEach(handler => handler.apply(this, args));
    }
  };

Object.assign(mediaDeviceClass.prototype, eventMixin);

export default mediaDeviceClass;